var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(_vm.showLocations)?_c('BaseThemeComponent',{attrs:{"name":"SectionLocations","title":"Pick a Location to View the Menu"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }